import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../../components/StyledButtons'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'

const WhitepaperDownloadForm = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    return (
        <div className='container pt-50' id="download-whitepaper-form" >
            <div className='whitepapers-form col-sm-12'>
                {language === "en"
                    ?
                    <div className='col-sm-12 col-lg-6 pt-lg-120 pb-20'>
                        <p className='whitepapers-form_title'>Enter Your Email To <span>Download</span> A Copy Now</p>
                    </div>
                    :
                    <div className='col-sm-12 col-lg-6 pt-lg-90 pb-20'>
                        <p className='whitepapers-form_title'>Nhập email của bạn để <span>tải xuống</span> bản sao ngay bây giờ</p>
                    </div>
                }
                <div className='col-sm-12 col-lg-6'>
                    <form>
                        <div className='row'>
                            <div className='form-group-primary col-lg-6'>
                                <p className='font-weight-bold'>{t('modal.default-form.full-name')} <span style={{color:"#FF3C00"}}>*</span></p>
                                <input type="text" placeholder='John' className='form-control-primary mt-10' />
                            </div>
                            <div className='form-group-primary col-lg-6'>
                                <p className='font-weight-bold'>
                                    {t('modal.default-form.phone-number')} 
                                    {/* <span style={{color:"#FF3C00"}}>*</span> */}
                                </p>
                                <input type="text" placeholder='Carter' className='form-control-primary mt-10' />
                            </div>
                            <div className='form-group-primary col-lg-12'>
                                <p className='font-weight-bold'>Email <span style={{color:"#FF3C00"}}>*</span></p>
                                <input type="text" placeholder='example@gmail.com' className='form-control-primary mt-10' />
                            </div>
                            <div className='col-lg-12'>
                                {language === "en"
                                    ?
                                    <p className='text-white'>Note: By clicking the “Download” button, you agree to receive communications from Qrypto. You can unsubscribe at any time.</p>
                                    :
                                    <p className='text-white'>Lưu ý: Bằng cách nhấp vào nút “Tải ngay, bạn đồng ý nhận thông tin liên lạc từ Qrypto. Bạn có thể bỏ theo dõi bất cứ lúc nào.</p>
                                }
                            </div>
                            <div className='col-lg-12 pt-30'>
                                <PrimaryButton disabled>{t('button.download-now')}</PrimaryButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default WhitepaperDownloadForm